var map = {
	"./mobildConfig.js": "XFBk"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "WU13";


//////////////////
// WEBPACK FOOTER
// ./src/store/design/modules nonrecursive \.js$
// module id = WU13
// module chunks = 134